import { IWindow } from '../../../../../../services/analytics/adapters/mparticle'
import { AnalyticsMetaKeys as key } from '../../../../../../services/analytics/formatters/meta-keys'
import { IProfile } from '../../../../../../services/common/profile'
import { DOMUtils } from '../../../../../../utils/dom'
import { UserEvents } from '../../user-events'

const mParticleEvents: any = new UserEvents()
declare let window: IWindow

export const SetAttributes = (result?: any, profile?: IProfile, meta?: any) => {

    if (profile) {
        // Set if the user age gated - must be a string value
        if (profile.ageOfMajority) {
            mParticleEvents.setUserAttribute(key.USER_CLAIMED_19_PLUS, String(profile.ageOfMajority))
        }
        // Set user's province into mParticle
        if (profile.province) {
            mParticleEvents.setUserAttribute(key.USER_PROVINCE, String(profile.province))
        }

        // Set user's postal code into mParticle
        if (profile.postalCode) {
            mParticleEvents.setUserAttribute(key.USER_PST_CDE, String(profile.postalCode))
        }

        if (profile.uuid) { mParticleEvents.setUserAttribute(key.USER_JANRAIN_ID, String(profile.uuid)) }
        if (profile.gender) { mParticleEvents.setUserAttribute(key.USER_GENDER, String(profile.gender)) }
        if (profile.lastSignIn) {
            mParticleEvents.setUserAttribute(key.USER_LAST_SIGN_IN, profile.lastSignIn.toISOString())
        }
        if (typeof profile.doNotContact !== 'undefined') {
            mParticleEvents.setUserAttribute(key.USER_DO_NOT_CONTACT, String(profile.doNotContact))
        }
        if (typeof profile.emailConfirmed !== 'undefined') {
            mParticleEvents.setUserAttribute(key.USER_EMAIL_CONFIRMED, String(profile.emailConfirmed))
        }
    }

    if (meta) {
        const brandAttrs = [key.BRAND, key.DIVISION, key.DISTRIBUTOR, key.VENDOR]
        brandAttrs.forEach((item) => {
            if (meta[item]) {
                mParticleEvents.setUserAttribute(item, String(meta[item]))
            }
        })
    }

    if (result) {
        // Set mParticle ID as user attribute
        const mParticleID = String(result.body.mpid)
        if (mParticleID) {
            if (profile) {
                profile.mpId = String(mParticleID)
            }
            mParticleEvents.setUserAttribute(key.USER_MPID, mParticleID)
        }
    }

    if (profile.subscriptions && profile.subscriptions.length > 0) {
        mParticleEvents.setUserAttribute(key.USER_ACNT_STATUS, 'Subscribed')
    } else if (profile.email) {
        mParticleEvents.setUserAttribute(key.USER_ACNT_STATUS, 'Registered')
    } else {
        mParticleEvents.setUserAttribute(key.USER_ACNT_STATUS, 'Not Registered')
    }

    mParticleEvents.setUserAttribute(key.USER_PASSED_AGE_GATE,
        (window.localStorage.getItem('page-age-gate-verified') || 'false'))
    mParticleEvents.setUserAttribute(key.SERVER, location.hostname)
    mParticleEvents.setUserAttribute(key.DEVICE_TYPE, DOMUtils.deviceType())
    mParticleEvents.setUserAttribute(key.DEVICE_ID, window.mParticle.getDeviceId())
    mParticleEvents.setUserAttribute(key.BROWSER_LG, navigator.language)
}
